/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 一括登録管理情報
 */
export interface ClusterRegistInfo { 
    /**
     * 一括登録管理番号
     */
    clusterRegistMNo?: string;
    /**
     * ＵＬファイル種別
     */
    fileCategory?: string;
    /**
     * 受付日付(yyyyMMdd)
     */
    acceptDate?: string;
    /**
     * 受付時刻：時刻(HHmmss)
     */
    acceptHms?: string;
    /**
     * 一括登録ステータス
     */
    clusteRegistStatus?: string;
    /**
     * 送信ファイル名
     */
    sendOriginlaFileName?: string;
    /**
     * システムコード
     */
    systemCode?: string;
    /**
     * ＤＬファイル種別
     */
    downloadFileCategory?: string;
    /**
     * ＤＬファイル名
     */
    downloadFileName?: string;
}

